import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { i18n } from '../i18n/translate.js';
import { TableauCloudChart } from './Charts/tableau-cloud-chart/component.js';
import { TableauChart } from './Charts/TableauChart/component.js';
import { ConstructionCard } from './ConstructionCard/component.js';
import { Layout } from '../core/components/Layout/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
import { toggleElementFullscreen } from '../utils/toggleElementFullscreen.js';

var ReportCard = function ReportCard(props) {
  var showViewMore = props.showViewMore,
      viewMoreUrl = props.viewMoreUrl,
      context = props.chartContext,
      tableau = props.tableau,
      relatedChartId = props.relatedChartId,
      showReportToolbar = props.showReportToolbar,
      viewMoreLabel = props.viewMoreLabel,
      filters = props.filters,
      displayErrorMessage = props.displayErrorMessage,
      errorMessage = props.errorMessage;
  var embedReportDiv = useRef(null);

  var getButtonConfig = function getButtonConfig() {
    if (!showViewMore) return null;
    var chartDiv = embedReportDiv.current ? embedReportDiv.current.children[0] : null;
    var button = {
      label: viewMoreLabel || i18n.t('View Report'),
      style: 'link',
      chakra: 'off',
      data: {
        action: 'action-dash-view-report',
        objectId: relatedChartId,
        objectType: 'chart'
      }
    };

    if (viewMoreUrl) {
      button.action = function () {
        window.open(viewMoreUrl, '_blank', 'noopener,noreferrer');
      };
    } else {
      button.action = function () {
        return toggleElementFullscreen(chartDiv);
      };
    }

    return [button];
  };

  var contextConfig = useMemo(function () {
    var _context$chart;

    if (!context) return null;

    switch (context.type) {
      case 'Datafi::TableauChartContext':
        return {
          ChartComponent: TableauChart,
          chartProps: {
            chartSourceUrl: context.iframe_src,
            tableau: tableau || window.tableau,
            filters: filters,
            chart: context.chart,
            showReportToolbar: showReportToolbar
          }
        };

      case 'Datafi::TableauCloudChartContext':
        return {
          ChartComponent: TableauCloudChart,
          chartProps: {
            tableau: window.tableauV3,
            filters: filters,
            context: context,
            showReportToolbar: (_context$chart = context.chart) === null || _context$chart === void 0 ? void 0 : _context$chart.show_toolbar,
            onError: displayErrorMessage,
            errorMessage: errorMessage
          }
        };

      default:
        throw new Error('Invalid chart type provided');
    }
  }, [context, filters]);

  if (!contextConfig) {
    return null;
  }

  var ChartComponent = contextConfig.ChartComponent,
      chartProps = contextConfig.chartProps;
  return /*#__PURE__*/React.createElement(Layout, {
    h: "560px",
    w: ['360px', '360px', '744px', null]
  }, /*#__PURE__*/React.createElement(ConstructionCard, _extends({}, props, {
    className: _formatClassName(['report-card', props.className]),
    buttonConfig: getButtonConfig(),
    alwaysExpanded: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "embed-report",
    ref: embedReportDiv
  }, /*#__PURE__*/React.createElement(ChartComponent, chartProps))));
};

ReportCard.displayName = "ReportCard";
ReportCard.propTypes = {
  chartContext: PropTypes.shape({
    chart: PropTypes.object.isRequired,
    iframe_src: PropTypes.string.isRequired,
    type: PropTypes.string
  }).isRequired,
  className: PropTypes.string,
  filters: PropTypes.object,
  relatedChartId: PropTypes.string,
  showReportToolbar: PropTypes.bool,
  showViewMore: PropTypes.bool,
  size: PropTypes.string,
  tableau: PropTypes.object,
  title: PropTypes.string.isRequired,
  viewMoreLabel: PropTypes.string,
  viewMoreUrl: PropTypes.string,
  displayErrorMessage: PropTypes.func,
  errorMessage: PropTypes.string
};
ReportCard.defaultProps = {
  showReportToolbar: false,
  showViewMore: false,
  size: 'narrow',
  tableau: window.tableau,
  titleSize: 18
};
export { ReportCard };